import type { SampleListParams } from '../services/sample.service';
import { legacySampleTypeStringToCode } from './sampleTypeLabels';

/** 詳細フィルターの種別をセレクト用コードに正規化（DB の日本語値・旧 URL との互換） */
export function sampleTypeFilterToUiCode(params: SampleListParams): SampleListParams {
  const st = params.sampleType;
  if (st === undefined || st === '') {
    return { ...params, sampleType: undefined };
  }
  return { ...params, sampleType: legacySampleTypeStringToCode(st) || st };
}

/**
 * 旧「サンプル名のみ」フィルターはキーワードに畳む（二重 UI を廃したあと孤児条件を残さない）
 */
export function foldNameFilterIntoSearch(params: SampleListParams): SampleListParams {
  if (!params.name) return params;
  const { name, ...rest } = params;
  if (rest.search) return { ...rest, name: undefined };
  return { ...rest, search: name, name: undefined };
}

export function normalizeSampleFiltersForUi(params: SampleListParams): SampleListParams {
  return foldNameFilterIntoSearch(sampleTypeFilterToUiCode(params));
}
